/**
 * This file was auto-generated by Fern from our API Definition.
 */

/**
 * The type of the link.
 */
export type ClaimsSchemaFieldLinkValueLinkType = 'REFERENCE';
export const ClaimsSchemaFieldLinkValueLinkType = {
    Reference: 'REFERENCE',
} as const;
